import React, { useEffect, useRef, useMemo } from "react";
import * as d3 from "d3";
import { useDimensions } from "./useDimensions";


const ProsecutionTime = () => {

    const data = useMemo(() => [
        { country: "china", averagedays: 365.8, median: 328, cn: "中国" },
        { country: "taiwan", averagedays: 740.8, median: 604.5, cn: "台湾" },
        { country: "japan", averagedays: 1274.2, median: 1145, cn: "日本" },
        { country: "usa", averagedays: 1473.2, median: 1132 , cn: "美国" }
    ], []); 


    const containerRef = useRef(null);
    const dimensions = useDimensions(containerRef);

    const svgRef = useRef();

    useEffect(() => {
        
        
        const margin = { top: 20, right: 4, bottom: 40, left: 40 };
        // const width = 600 - margin.left - margin.right;
        const height = 250 - margin.top - margin.bottom;
        const { width } = dimensions;

        d3.select(svgRef.current).selectAll('*').remove();

        const svg = d3.select(svgRef.current)
            .attr("width", width)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform", `translate(${margin.left},${margin.top})`);

        

        const xScale = d3.scaleLinear()
            .domain([0, 1500])
            .range([0, width - margin.left - margin.right]);

        const yScale = d3.scaleBand()
            .domain(data.map(d => d.cn))
            .range([0, height - margin.top, margin.bottom])
            .padding(0.6);

        svg.append("g")
            .style("font-size", "12px")
            .style("letter-spacing", "1px")
            .call(d3.axisLeft(yScale)
                .tickSize(0)
                .tickPadding(10)
            )
            .select(".domain")
            .attr("stroke", "none");

        svg.append("g")
            .attr("class", "x-axis")
            .attr("transform", `translate(0,${height - margin.top})`)
            .call(d3.axisBottom(xScale)
                .tickSize(0)
                .tickPadding(10)
                .tickFormat((d) => d !== 0 ? d : ""));

        svg.append("text")
            .attr("class", "axes")
            .attr("y", height + 2)
            .attr("x", -35)
            .text("案件审理天数");

        const Tooltip = d3.select("body")
            .append("div")
            .attr("class", "tooltip")
            .style("opacity", 0);

        const handleMouseOver = (event, d) => {
            Tooltip.style("opacity", 1);
            d3.select(event.currentTarget)
                .transition()
                .duration(200)
                .attr("stroke", "#fff");
        };

        const handleMouseMove = (event, d) => {
            const isBar = event.currentTarget.tagName === "rect";
            const tooltipContent = isBar ?
                `<span style="color:var(--${d.country}"><b>${d.cn}</b></span><br>
                可查的最终判决<b>平均</b>天数：<span class="tooltip__num">${d.averagedays}</span>天`
                : `<span style="color:var(--${d.country}"><b>${d.cn}</b></span><br>
                可查的最终判决<b>中位</b>天数：<span class="tooltip__num">${d.median}天
                </span>`

            Tooltip
                .html(tooltipContent)
                .style("left", (event.pageX + 10) + "px")
                .style("top", (event.pageY + 10) + "px");
                
        };

        const handleMouseOut = (event, d) => {
            Tooltip.style("opacity", 0);
            d3.select(event.currentTarget)
                .transition()
                .duration(200)
                .attr("stroke", d => `var(--${d.country})`);
        };

        svg.selectAll(".bar")
            .data(data)
            .enter()
            .append("rect")
            .attr("y", d => yScale(d.cn))
            // .attr("width", d => xScale(d.averagedays))
            .attr("width", d => Math.max(0, xScale(d.averagedays)))
            .attr("height", yScale.bandwidth())
            .attr("fill", d => `var(--${d.country})`)
            .attr("fill-opacity", 0.7)
            .attr("stroke", d => `var(--${d.country})`)
            .attr("stroke-opacity", 1)
            .on("mouseover", handleMouseOver)
            .on("mousemove", handleMouseMove)
            .on("mouseout", handleMouseOut);

        svg.selectAll(".median-line")
            .data(data)
            .enter()
            .append("line")
            .attr("x1", d => xScale(d.median))
            .attr("x2", d => xScale(d.median))
            .attr("y1", d => yScale(d.cn) - 6)
            .attr("y2", d => yScale(d.cn) + yScale.bandwidth() + 6)
            .attr("stroke", d => `var(--${d.country})`)
            .attr("stroke-width", 3)
            .on("mouseover", handleMouseOver)
            .on("mousemove", handleMouseMove)
            .on("mouseout", handleMouseOut);;

    }, [data, dimensions]);

  return (
    <div className="center-container">
        <div className="article-body">
            <h2>案发后火速审理“平息民愤”，但很可能缺乏对程序的尊重</h2>
            <div className="spacerdiv" />
            <p>从中国互联网上能追踪到的79宗案件中，歪脑发现中国无差别袭击事件从案发到判决的平均天数远少于同期美国日本和台湾的天数。诚然，各国的司法体制不尽相同，但从案件审理的时间我们也可一窥各国对生命的态度。</p>
        </div>
        
        <div ref={containerRef} className="container-ref">
            <h4>无差别案件的侦查和审理过程的时间</h4>
            <svg ref={svgRef}></svg>
        </div>
        <div className="article-body">
            
            <p>中国最短的案件审理时间发生在2010年4月, 犯罪嫌疑人<a href="https://www.bbc.com/zhongwen/simp/china/2010/05/100530_jiangsu_kindergarten" target="_blank">闯进</a>江苏泰兴一家幼儿园，砍伤32名师生。从案发到执行死刑仅花了31天。而在2024年11月发生的最近两场袭击，都只用了不足70天就执行了判决，其审判速度之快是<a href="https://www.rfa.org/mandarin/zhengzhi/renquan/2024/12/27/kw-china-zhuhai-death-pennalty/" target="_blank">外界讨论</a>的焦点。与中国法律体系更为接近的日本，案件审理时间最短的案件同样发生在一所<a href="https://researchmap.jp/yakahane/published_papers/35353134/attachment_file.pdf" target="_blank">幼儿园</a>，位于东京，嫌疑人砍伤了两名一年级的儿童，从案发到被判三年监禁，用了1145天。在美国，审理时间最短的案件是2021年3月16日在亚特兰大发生无差别袭击事件，嫌疑人枪杀了8名亚裔按摩师，导致1人受伤，事发114天后被判决。</p>
            <p>具体来看中国的数据，我们发现在2010年和2020年疫情开始后，案件处理时间尤为快。律师滕彪研究中国死刑，他认为，中国各时期政治社会因素会影响到司法审判。例如，2010年是“严打年”，全称为严厉打击形势犯罪活动。为控制当时的高犯罪率，从1949年以来，中国已施行了四次“严打”，最近的一次是在2010年。滕彪观察，“严打年”通常案件的审理到判决速度都会更快。歪脑整理的数据显示，2010年发生了3起无差别袭击事件，案件处理为37天，远低于平均审理时间。更深层的原因是中国司法行政化，司法不独立。 </p>
            <p>另外，习近平在2013年就任国家主席以后, 进行司法公开、以庭审为中心一系列<a href="http://iolaw.cssn.cn/fxyjdt/201906/t20190620_4921301.shtml" target="_blank">司法改革</a>。歪脑观察到，相较之前，无差别袭击事件案件审理时间也更长一些。但自疫情以来，审理时间又有缩减，滕彪认为，这是为了更快“平息民愤”。而刑事诉讼法中所规定的侦查、逮捕、预审、起诉、审判等程序，大多都被忽视了。</p>
        </div>

    </div>
  )
}

export default ProsecutionTime;